import { PostRequest } from "./http/BaseRequest";

export class ChangeClientPass extends PostRequest {
  constructor(userId: string, password: string) {
    super("/user/reset_password", { user_id: userId, password });
  }
}
